import { bool } from "prop-types";

import Loading from "web/Layout/Common/Loading";

import classes from "./loader.scss";

const Loader = ({ isLoading }) => {
  return isLoading ? (
    <div className={classes.root}>
      <Loading className={classes.loader} />
    </div>
  ) : null;
};

Loader.propTypes = {
  isLoading: bool,
};

Loader.defaultProps = {
  isLoading: false,
};

export default Loader;
